import React, { Component, useState, useEffect } from 'react';
import { CircularProgress, Paper, Grid, IconButton, Tabs, Tab } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import LogoAndTitle from '../../Layout/components/LogoAndTitle';
import { TabPanel } from '../../Common/TabPanel';
import ContactPersonDetails from './ContactPersonDetails';
import LocationDetails from './LocationDetails';
import { LocationAddress } from '../../api/models/LocationAddress';
import { ContactPersonData } from '../../api/models/ContactPersonData';
import AccountTabContent from './AccountTabContent';
import { RootState } from 'typesafe-actions';
import { useSelector, useDispatch } from 'react-redux';
import { browserHistory } from '../../store/store';
import { setAccountInfoAsyncThunk, getRestaurantInfoAsyncThunk, getSupplierInfoAsyncThunk } from '../accountDetailsSlice';
import RestaurantPaymentCards from './RestaurantPaymentCards';



export default function AccountDetails() {
    const dispatch = useDispatch()
    const [currentTab, setCurrentTab] = useState(0)
    const _accountDetails = useSelector((state: RootState) => state.accountDetailsRdc)
    const _auth = useSelector((state: RootState) => state.authRdc)

    useEffect(() => {
        if (isRestaurant()) {
            dispatch(getRestaurantInfoAsyncThunk())
        } else {
            if (isSupplier())
                dispatch(getSupplierInfoAsyncThunk())
            else
                browserHistory.push("/Login")
        }
    }, [])

    const isRestaurant = (): boolean => {
        return _auth.userRole === "Restaurant"
    }
    const isSupplier = (): boolean => {
        return _auth.userRole === "Supplier"
    }

    return (
        <div>
            <Grid container alignItems="center">
                <Grid item sm={1} style={{ textAlign: 'center' }}>
                    <IconButton size="medium" onClick={() => browserHistory.push('/')}><ArrowBack fontSize="large" /></IconButton>
                </Grid>
                <Grid item sm={11}>
                    <LogoAndTitle title="Your account details" />
                </Grid>
            </Grid>

            {_accountDetails.loadUserDetailsBusy ?
                <CircularProgress size={50} />

                :
                <Paper style={{ padding: '15px' }}>
                    <Tabs
                        value={currentTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, v) => setCurrentTab(v)}
                        aria-label="account-details"
                    >
                        <Tab label="ACCOUNT">
                        </Tab>
                        <Tab label="LOCATION">
                        </Tab>
                        <Tab label="PAYMENT">
                        </Tab>

                    </Tabs>

                    <TabPanel value={currentTab} index={0}>
                        <AccountTabContent title="Your account details">
                            {isRestaurant() && _accountDetails.restaurantDetails &&
                                <ContactPersonDetails contactPersonData={_accountDetails.restaurantDetails} updateAccountInfoSuccess={_accountDetails.updateAccountInfoSuccess} updateContactPersonDataBusy={_accountDetails.updateAccountInfoBusy} updateContactPersonData={(cpData: ContactPersonData) => { dispatch(setAccountInfoAsyncThunk({ restaurantData: Object.assign({}, _accountDetails.restaurantDetails, cpData) })) }} />
                            }

                            {isSupplier() && _accountDetails.supplierDetails &&
                                <ContactPersonDetails contactPersonData={_accountDetails.supplierDetails} updateAccountInfoSuccess={_accountDetails.updateAccountInfoSuccess} updateContactPersonDataBusy={_accountDetails.updateAccountInfoBusy} updateContactPersonData={(cpData: ContactPersonData) => { dispatch(setAccountInfoAsyncThunk({ supplierData: Object.assign({}, _accountDetails.supplierDetails, cpData) })) }} />
                            }
                        </AccountTabContent>
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <AccountTabContent title="Your location details">
                            {isRestaurant() && _accountDetails.restaurantDetails &&
                                <LocationDetails locationData={_accountDetails.restaurantDetails} updateAccountInfoSuccess={_accountDetails.updateAccountInfoSuccess} updateLocationDataBusy={_accountDetails.updateAccountInfoBusy} updateLocationData={(locData: LocationAddress) => { dispatch(setAccountInfoAsyncThunk({ restaurantData: Object.assign({}, _accountDetails.restaurantDetails, locData) })) }} />
                            }

                            {isSupplier() && _accountDetails.supplierDetails &&
                                <LocationDetails locationData={_accountDetails.supplierDetails} updateAccountInfoSuccess={_accountDetails.updateAccountInfoSuccess} updateLocationDataBusy={_accountDetails.updateAccountInfoBusy} updateLocationData={(locData: LocationAddress) => { dispatch(setAccountInfoAsyncThunk({ supplierData: Object.assign({}, _accountDetails.supplierDetails, locData) })) }} />
                            }
                        </AccountTabContent>
                    </TabPanel>
                    <TabPanel value={currentTab} index={2}>
                        <AccountTabContent title="Your cards">
                            {(isRestaurant() && _accountDetails.restaurantDetails) &&
                                <RestaurantPaymentCards/>
                            }
                        </AccountTabContent>
                    </TabPanel>


                </Paper>
            }
        </div>
    );
}